import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProjectDto } from '@app/admin/models/project-dto';
import { buildProjectForm } from '@admin/pages/projects/util/project-form-builder';
import { convertToUTC } from '@admin/pages/projects/util/date-helper';
import { Store } from '@ngrx/store';
import { AddProject } from '@dwo/actions';

@Component({
  selector: 'app-add-project',
  templateUrl: './add-project.component.html',
  styleUrls: ['./add-project.component.scss'],
  standalone: false,
})
export class AddProjectComponent {
  readonly form: UntypedFormGroup;
  readonly divisionTypes: string[] = ['OFFSHORE', 'FABRICATION'];
  readonly completionSystems: string[] = ['COMPLETION', 'PROCOSYS', 'PIMS'];
  readonly originTypes: string[] = ['MIPS'];
  readonly progressCutOffDay: string[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  constructor(
    formBuilder: UntypedFormBuilder,
    private readonly dialogRef: MatDialogRef<AddProjectComponent>,
    private readonly store: Store,
  ) {
    this.form = buildProjectForm(formBuilder);
  }

  onAdd(): void {
    if (!this.form.valid) {
      return;
    }

    const project = { ...this.form.getRawValue() } as ProjectDto;
    if (project.progressCutOffTime) {
      project.progressCutOffTime = convertToUTC(project.progressCutOffTime);
    }

    this.store.dispatch(new AddProject(project));
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
